import { useAuth } from '@/app/providers/AuthProvider';
import { ShieldAlert, LogOut, Mail, Clock } from 'lucide-react';

export function AwaitingInviteScreen() {
  const { user, signOut } = useAuth();

  return (
    <main className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-midnight px-6 py-12 text-ink">
      {/* Aurora background */}
      <div className="absolute inset-0 -z-10 mesh-midnight">
        <div
          className="aurora-orb aurora-orb-accent animate-aurora-1"
          style={{ width: 480, height: 480, top: '-10%', left: '-15%', opacity: 0.4 }}
        />
        <div
          className="aurora-orb aurora-orb-violet animate-aurora-2"
          style={{ width: 420, height: 420, bottom: '-12%', right: '-12%', opacity: 0.35 }}
        />
      </div>

      <div className="w-full max-w-md space-y-8 animate-fade-in">
        <div className="rounded-3xl glass-strong shadow-deep p-8 space-y-7 text-center">
          <div className="relative mx-auto h-20 w-20">
            <div className="absolute inset-0 rounded-full blur-2xl bg-accent/40 animate-pulse" />
            <div className="relative flex h-20 w-20 items-center justify-center rounded-full glass border border-accent/30">
              <ShieldAlert className="h-9 w-9 text-accent" />
            </div>
          </div>

          <div className="space-y-3">
            <span className="inline-flex items-center gap-1.5 rounded-full glass px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-accent">
              <Clock className="h-3 w-3" />
              <span>Aguardando convite</span>
            </span>
            <h1 className="font-display text-2xl font-bold tracking-tight text-white">
              Quase lá.
            </h1>
            <p className="text-sm text-ink-muted leading-relaxed">
              O Lumenise Base é uma plataforma multi-tenant privada. Sua conta foi autenticada,
              mas ainda não está associada a nenhuma campanha ou mandato.
            </p>
          </div>

          <div className="flex items-center gap-3 rounded-xl glass p-4 text-left">
            <Mail className="h-5 w-5 shrink-0 text-accent" />
            <div className="min-w-0 overflow-hidden">
              <p className="font-mono text-[10px] uppercase tracking-wider text-ink-subtle">
                E-mail autenticado
              </p>
              <p className="truncate font-mono text-sm font-semibold text-white">{user?.email}</p>
            </div>
          </div>

          <div className="space-y-4 pt-1">
            <p className="text-xs text-ink-muted leading-relaxed">
              Solicite ao gestor da sua campanha o envio de um convite para este e-mail. Assim
              que o convite for cadastrado, você terá acesso imediato no próximo login.
            </p>

            <button
              onClick={() => void signOut()}
              className="flex w-full items-center justify-center gap-2 rounded-xl btn-ghost py-3 px-4 text-sm font-semibold cursor-pointer"
            >
              <LogOut className="h-4 w-4" />
              <span>Sair da conta</span>
            </button>
          </div>
        </div>

        <p className="text-center text-[11px] text-ink-subtle font-mono">
          Lumenise Base · Multi-tenant · LGPD
        </p>
      </div>
    </main>
  );
}
